<template>
  <div>
    <!-- 头部信息区 -->
    <!-- <div class="info-wrap">
      <img :src="userinfo.thumbAvatar" class="avatar" alt="" />
      <span>{{ userinfo.nickName }}</span>
    </div> -->
    <!-- 信息列表区 -->
    <div class="info-list">
      <div class="info-one">
        <van-form ref="form" :readonly="isExamine" validate-trigger="onSubmit">
          <!-- <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }" content-position="left">基本信息</van-divider> -->
          <van-cell style="padding-left: 8px; font-weight: bold" title="基本信息" />
          <van-field v-model="form.sexName" label="性别" placeholder="请选择性别" left-icon="circle" readonly
            @click="showPicker('sex')" :rules="[{ required: true }]" required/>
          <van-field v-model="form.isMarriageName" label="婚否" placeholder="请选择" left-icon="like-o" readonly
            @click="showPicker('isMarriage')" :rules="[{ required: true }]" required/>
          <van-field v-model="form.nativePlaceName" label="籍贯" placeholder="请选择籍贯所在地" left-icon="contact" readonly
            @click="showPicker('nativePlace')" :rules="[{ required: true }]" required/>
          <van-field v-model="form.birthday" label="生日" placeholder="请选择您的生日日期" left-icon="birthday-cake-o" readonly
            @click="birthdayVisible = true" :rules="[{ required: true }]" required/>
          <van-field v-model="form.identityCard" label="身份证" placeholder="请输入您的身份证号" left-icon="idcard" maxLength="18"
            :rules="[{ required: true },
            { pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '身份证号输入有误！'}]"
            required/>
          <van-field v-model="form.educationName" label="学历" placeholder="请选择您的学历" left-icon="orders-o" readonly
            @click="showPicker('education')" :rules="[{ required: true }]" required />
          <van-field v-model="form.major" label="专业" placeholder="请输入您的专业" left-icon="description"
            :rules="[{ required: true }]" required />
          <van-field v-model="form.universityGraduated" label="毕业校院" placeholder="请输入您的毕业校院" left-icon="wap-home-o"
            :rules="[{ required: true }]" required />

          <!-- <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }" content-position="left">联系信息</van-divider> -->
          <van-cell style="padding-left: 8px; font-weight: bold; margin-top: 10px;" title="联系信息" />
          <van-field v-model="form.phone" readonly label="手机"
              type="tel" left-icon="phone-o" />
              <!-- :rules="[
                { required: true, message: '请填写您的手机号码！' },
                { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}
              ]" required  -->
          <van-field v-model="form.email" readonly label="邮箱" left-icon="envelop-o" />
          <van-field v-model="form.emergencyContact" label="紧急联系人及电话" placeholder="请输入您紧急联系人及电话" left-icon="phone-circle-o"
            :rules="[{ required: true }]" required />
          <van-field v-model="form.wx" label="微信号" placeholder="请输入您的微信号" left-icon="chat-o" />
          <van-field v-model="form.qq" label="QQ号" placeholder="请输入您的QQ号" left-icon="goods-collect-o" />

          <!-- <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }" content-position="left">入职信息</van-divider> -->
          <van-cell style="padding-left: 8px; font-weight: bold; margin-top: 10px;" title="入职信息" />
          <van-field v-model="form.deptName" readonly label="部门" left-icon="coupon-o" />
          <van-field v-model="value" label="岗位" placeholder="请输入您的岗位" left-icon="friends-o" @click="showpost=true" />
          <van-field v-model="form.postName" label="职务" placeholder="请输入您的职务" left-icon="manager-o" />
          <van-field v-model="form.entryTime" label="入职时间" placeholder="请选择您的入职时间" left-icon="share-o" readonly
            @click="handelDate('entryTime')" :rules="[{ required: true }]" required/>
          <van-field v-model="sytime" label="试用时间" placeholder="请选择试用开始时间" left-icon="aim" readonly
            @click="rangeShow = true" :rules="[{ required: true }]" required/>
          <van-field v-model="form.regularTime" label="转正时间" placeholder="请选择转正时间" left-icon="tosend" readonly
            @click="handelDate('regularTime')" :rules="[{ required: true }]" required/>
          <van-field v-model="form.contractTime" label="劳动合同签订时间" placeholder="请选择劳动合同签订时间" left-icon="discount" readonly
            @click="handelDate('contractTime')" />

          <van-button v-preventReClick class="addBtn" round block type="info" native-type="submit" size="small" @click="handleAdd">保存</van-button>
        </van-form>
      </div>
    </div>
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
    <van-calendar v-model="datePicker.visible" :min-date="minDate" :max-date="maxDate" type="single" @confirm="dateCalendarConfirm" />
    <!-- 选择日期区间 -->
    <van-calendar v-model="rangeShow" :min-date="minDate" type="range" @confirm="onConfirm" />

    <!-- 选择生日 -->
    <van-popup v-model="birthdayVisible" position="bottom">
      <van-datetime-picker
        v-model="birthdayDate"
        type="date"
        title="选择出生日期"
        :min-date="birthdayMinDate"
        :max-date="birthdayMaxDate"
        @confirm="birthdayConfirm"
        @cancel="birthdayVisible = false"
      />
    </van-popup>
  </div>
</template>

<script>

import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  Field,
  Dialog,
  Form,
  Toast,
  DatetimePicker
} from 'vant'
import { getUserProfileInfor } from '@/api/admi/user'
import { mapGetters } from 'vuex'
// import { resetUserPwd } from '@/api/system/user'
// import { listArchives } from '@/api/admi/ps_archives'
import { getDicts } from '@/api/system/dict/data'

export default {
  name: 'ShezhiIndex',
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    [Form.name]: Form,
    [CellGroup.name]: CellGroup,
    [DatetimePicker.name]: DatetimePicker
    // ActionSheet
  },
  computed: {
    ...mapGetters({
      userinfo: 'userinfo'
    }),
    sex() {
      return this.selectDictLabel(this.options.sexOptions, this.form.sex)
    },
    isMarriage() {
      return this.selectDictLabel(this.options.isMarriageOptions, this.form.isMarriage)
    },
    nativePlace() {
      return this.selectDictLabel(this.options.nativePlaceOptions, this.form.nativePlace)
    },
    education() {
      return this.selectDictLabel(this.options.educationOptions, this.form.education)
    }
  },
  props: {},
  data() {
    return {
      isExamine: false, // 数据是否审核，表单是否可操作
      // userProfileInfor: {},// 用户档案信息
      form: {},
      sytime: '', // 使用时间
      options: {
        // 籍贯字典
        nativePlaceOptions: [],
        // 学历类型
        educationOptions: [],
        // 婚姻状况字典
        isMarriageOptions: [],
        // 性别状态字典
        sexOptions: []
      },
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: ''
      }, // 弹窗状态
      datePicker: {
        visible: false,
        title: '',
        formKey: '',
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(2042, 11, 31)
      }, // 日期选择状态
      // 选择日期区间弹窗
      rangeShow: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2042, 11, 31),
      // 选择生日弹窗
      birthdayVisible: false,
      birthdayDate: new Date(),
      birthdayMinDate: new Date(1920, 0, 1),
      birthdayMaxDate: new Date(),
      // 在职状态弹出层
      showjob: false,
      value: ''
    }
  },
  watch: {},
  async created() {
    this.getOptions()
    await this.getUserProfileInfor()
    console.log('userinfo', this.userinfo)
    // this.form = {
    //     userId: this.userinfo.userId,
    //     deptName: this.userinfo.dept.deptName || this.userProfileInfor.deptName,
    //     phone: this.userinfo.mobile || this.userProfileInfor.phone,
    //     email: this.userinfo.email || this.userProfileInfor.email,
    //     postName: this.userinfo.position || this.userProfileInfor.postName,
    //     identityCard: this.userProfileInfor.identityCard,
    //     sex: this.userinfo.sex || this.userProfileInfor.sex,
    //     isMarriage: this.userProfileInfor.isMarriage,
    //     nativePlace: this.userProfileInfor.nativePlace,
    //     birthday: this.userProfileInfor.birthday,
    //     entryTime: this.userProfileInfor.entryTime,
    //     trialStartTime: this.userProfileInfor.trialStartTime,
    //     trialEndTime: this.userProfileInfor.trialEndTime,
    //     regularTime: this.userProfileInfor.regularTime,
    //     contractTime: this.userProfileInfor.contractTime,
    //     education: this.userProfileInfor.education,
    //     major: this.userProfileInfor.major,
    //     universityGraduated: this.userProfileInfor.universityGraduated,
    //     emergencyContact: this.userProfileInfor.emergencyContact,
    //     wx: this.userProfileInfor.wx,
    //     qq: this.userProfileInfor.qq
    //   }
  },
  mounted() {
    this.getDicts('native_place').then(response => {
      this.claimStatusOptions = response.data
    })

    this.init()
    // this.listArchives();
  },
  methods: {

    Native(type) {
      // console.log("test:" + JSON.stringify( this.options));
      if (type === 'nativePlace') {
        this.picker.formKey = type
        this.picker.columns = this.nativePlaceOptions.map((ele) => ele.dictLabel)
      }
    },
    // mounted(){
    //   this.getOptions();
    // },
    getOptions() {
      // 籍贯
      getDicts('native_place').then(res => {
        this.options.nativePlaceOptions = res.data
      })
      // 学历
      getDicts('sys_education').then(res => {
        this.options.educationOptions = res.data
      })
      // 性别
      getDicts('sys_user_sex').then(res => {
        this.options.sexOptions = res.data
      })
      // 婚姻状况
      getDicts('admi_marriage_type').then(res => {
        this.options.isMarriageOptions = res.data
      })
    },
    // 获取用户档案信息
    async getUserProfileInfor() {
      const res = await getUserProfileInfor(this.userinfo.userId)
      if (res.code === 200) {
        // this.userProfileInfor = res.data
        if (res.data) {
          this.form = res.data
          this.sytime = res.data.trialStartTime + res.data.trialEndTime
          if (res.data.verifyStatus === '1') {
            this.isExamine = true
          } else if (res.data.verifyStatus === '2') {
            Toast.fail('审核不通过，请重新输入并提交')
          }
        }
      }
    },
    async init() {
      // 修改主体框架标题
      document.title = '个人档案'
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.showjob = false
      Toast(item.name)
    },
    // 弹出层
    showPicker(type) {
      if (this.isExamine === true) { return }
      this.picker.formKey = type
      const optionItem = type + 'Options'
      this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
      this.picker.visible = true
    },
    // 弹出层确认
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      console.log('key:' + key)
      const name = this.picker.formKey + 'Name'
      this.form[this.picker.formKey] = this.options[optionItem][key].dictValue
      this.form[name] = this.options[optionItem][key].dictLabel
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    pickerChange() { },
    handelDate(type) {
      if (this.isExamine === true) { return }
      this.datePicker.formKey = type
      this.datePicker.visible = true
    },
    dateCalendarConfirm(date) {
      this.form[this.datePicker.formKey] = this.formatDate(date)
      this.datePicker.visible = false
      // this.minDate = date
    }, // 日期确认
    onConfirm(date) {
      const [start, end] = date
      this.rangeShow = false
      this.form.trialStartTime = this.formatDate2(start)
      this.form.trialEndTime = this.formatDate2(end)
      this.sytime = `${this.formatDate2(start)}  -  ${this.formatDate2(end)}`
    },
    formatDate(date) {
      //  日期格式化
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    formatDate2(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    birthdayConfirm(date) {
      this.form.birthday = this.formatDate(date)
      this.birthdayVisible = false
    },
    // 保存提交
    async handleAdd() {
      await this.$refs.form.validate()
      console.log(this.form)
      // addUserProfileInfor(this.form).then((response) => {
      //   if(response.code === 200){
      //     Toast.success("保存提交成功，请等待审核")
      //   } else {
      //     Toast.fail(response.message)
      //   }
      // });
    }
    //  async listArchives(){
    //   const {rows} = await listArchives()
    //   console.log(rows);
    //   }
    // 点击出修改密码弹框
    // changePass() {
    //   this.passValue = "";
    //   this.showTitle = '请输入"' + this.userinfo.userName + '"的新密码';
    //   this.showPassword = true;
    // },
    // beforeClose(action, done) {
    //   console.log(action);
    //   if (action == 'confirm') {
    //     if (this.passValue === "") {
    //       Toast("请输入新密码");
    //       done(false)
    //     } else {
    //       resetUserPwd(this.userinfo.userId, this.passValue).then((response) => {
    //         Toast("修改成功，新密码是：" + value);
    //       });
    //       done()
    //     }
    //   }

    //   if (action == 'cancel') {
    //     done()
    //   }
    // },
  }
  /** 重置密码按钮操作 */
  // handleResetPwd() { },
}
</script>

<style scoped lang='less'>
@import url("@/style/index.less");

// .info-wrap {
//   z-index: 10;
//   position: fixed;
//   top: 0;
//   width: 100%;
//   height: 300px;
//   background: linear-gradient(90deg, #1890ff 0%, #4d74f5 26%, #2cb5e8 75%);
//   color: white;
//   opacity: 0.95;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;

//   // .info {
//   //   position: absolute;
//   //   width: 90%;
//   //   height: 250px;
//   //   border-radius: 10px;
//   //   background-color: #fff;
//   //   margin-top: 100px;
//   //   -moz-box-shadow: 2px 2px 5px #333333;
//   //   -webkit-box-shadow: 2px 2px 5px #333333;
//   //   box-shadow: 2px 2px 5px #333333;
//   //   display: flex;
//   //   flex-direction: column;
//   //   align-items: center;
//   //   justify-content: center;
//   // }

//   .avatar {
//     width: 100px;
//     height: 100px;
//     border-radius: 50%;
//   }

//   span {
//     font-size: 28px;
//     margin-top: 40px;
//     font-weight: 500;
//   }
// }

  .info-list {
    // border-top: 1px solid #ddd;
    overflow-y:visible;
    padding-bottom: 100px;
    // margin-top: 320px;
  }
// .user {
//   &-poster {
//     width: 100%;
//     height: 53vw;
//     display: block;
//   }

//   &-group {
//     margin-bottom: 15px;
//   }

//   &-links {
//     padding: 15px 0;
//     font-size: 12px;
//     text-align: center;
//     background-color: #fff;

//     .van-icon {
//       display: block;
//       font-size: 24px;
//     }
//   }

// }
</style>
